import React from 'react';
import styled from 'styled-components';
import { ICommentInput } from '../../../utils/apollo/graphqlSchema';
import { theme } from '../../../styles/theme';
import ThreadIndicator from '../ThreadIndicator';
import ConversationInput from '../ConversationInput';
import { THREAD_POPOVER_WIDTH } from '../constants';
import { ICommentInputInfo } from '../types';

interface IProps {
  onSubmit: (
    commentInput: ICommentInput,
    commentInputInfo: ICommentInputInfo,
  ) => Promise<void>;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  width: ${THREAD_POPOVER_WIDTH}px;
`;
const StyledConversationInput = styled(ConversationInput)`
  box-shadow: ${theme.effects.shadow2};
`;

const StartThreadPopover = ({ onSubmit }: IProps) => {
  return (
    <Container>
      <ThreadIndicator />
      <StyledConversationInput
        isUpdate={false}
        onSubmit={onSubmit}
        placeholder="Add a comment"
      />
    </Container>
  );
};

export default StartThreadPopover;
